import { createMuiTheme } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple'



const Theme = createMuiTheme({
  palette: {

    primary: {  main: '#002c76', contrastText: '#ffffff',},
    secondary: purple,
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  status: {
    danger: 'red',
  },
  body: { 
          margin: '0 auto',
          fontFamily: 'montserratregular' },

  colors:{
    uptime:{primary:"#41B900"},
    downtime:{primary:"#C2272D"},
    parcial:{primary:"#FFC600"},
    back:{primary:"#313131", secondary:"#737373", last:" #A9A9A9", white:"#ffffff"},
  },
  typography: { fontFamily: [ 'montserratregular' ].join(','), },

});

export default Theme;